import { __awaiter, __generator } from "tslib";
import { fetchProductAttributes } from '@gn-audio/core';
import { fetchProductsBySkus } from '@gn-audio/core/api/product-catalogue/fetch-products-by-skus';
/**
 * Checks whether a service is allowed for a locale
 * @param sku Service SKU to check (External reference ID)
 * @param serviceType Type of the service attached to the master product
 * @returns Boolean value indicating whether service is allowed for product on a specific locale
 * @async
 */
export var isServiceAllowedForLocale = function (sku, serviceType) { return __awaiter(void 0, void 0, void 0, function () {
    var products, productId, productAttributes, serviceAttribute;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchProductsBySkus([sku])];
            case 1:
                products = _a.sent();
                if (!(products === null || products === void 0 ? void 0 : products.length)) {
                    return [2 /*return*/, false];
                }
                productId = products[0].productId;
                return [4 /*yield*/, fetchProductAttributes(productId)];
            case 2:
                productAttributes = _a.sent();
                if (productAttributes === null) {
                    return [2 /*return*/, false];
                }
                serviceAttribute = productAttributes.some(function (a) { return a.valueKey === serviceType; });
                return [2 /*return*/, serviceAttribute];
        }
    });
}); };
